import { HiOutlineCalendar } from 'react-icons/hi';
import PlanDetailsDialog from '@/app/components/PlanDetailsDialog';
import type { StructuredCard } from './types';
import { trpc } from '@/app/api/trpc/client';
import { unescapeHtmlEntities } from '@/utils/stringUtils';
import { useState } from 'react';

type PlanPreviewData = {
  id?: string;
  name?: string;
  lengthWeeks?: number;
};

export const PlanPreviewCard = ({
  card,
}: {
  card: StructuredCard & { content: string };
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  let previewData: PlanPreviewData | null = null;

  try {
    previewData = JSON.parse(card.content);
  } catch (e) {
    console.error('Failed to parse plan_preview content:', e);
  }

  // Fetch full plan details for the dialog
  const { data: fullPlan } = trpc.workouts.getPlanById.useQuery(
    { id: previewData?.id || '' },
    { enabled: isDialogOpen && !!previewData?.id }
  );

  if (!previewData) {
    return null;
  }

  return (
    <>
      <button
        className='flex items-center gap-2 px-3 py-2 bg-emerald-50 dark:bg-emerald-950/30 hover:bg-emerald-100 dark:hover:bg-emerald-900/50 border border-emerald-200 dark:border-emerald-800 rounded-xl transition-all shadow-sm group text-emerald-700 dark:text-emerald-300'
        onClick={() => setIsDialogOpen(true)}
      >
        <HiOutlineCalendar className='h-4 w-4' />
        <span className='text-sm font-semibold'>
          {unescapeHtmlEntities(previewData.name || 'Training Plan')}
        </span>
        {typeof previewData.lengthWeeks === 'number' &&
          previewData.lengthWeeks > 0 && (
            <span className='text-[10px] bg-emerald-200/50 dark:bg-emerald-800/50 px-1.5 py-0.5 rounded ml-1'>
              {previewData.lengthWeeks}w
            </span>
          )}
      </button>

      <PlanDetailsDialog
        plan={fullPlan ?? null}
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      />
    </>
  );
};
